module.exports = __webpack_public_path__ + "static/media/alexa.b643edb7.svg";